import isUndefined from 'lodash/isUndefined';
import get from 'lodash/get';

/**
 * Creates a new InputEmailController.
 * @class
 * @extends InputController
 */
class InputEmailController {
    /**
     * @constructor
     * @param $ngRedux
     * @param $filter
     */
    constructor($ngRedux, $filter) {
        this.$ngRedux = $ngRedux;
        this.input = null;
        this.$filter = $filter;
    }

    $onInit() {
        if (isUndefined(this.name))
            throw new Error('Missing input name attribute');
        if (isUndefined(this.identifier))
            throw new Error('Missing input ' + this.name + ' identifier attribute');
        if (isUndefined(this.label))
            this.label = this.$filter('translate')("");
        if (isUndefined(this.disable))
            this.disable = false;

        this.unsubscribeModule = this.$ngRedux.connect(this.mapModule, {})(this);
        if (this.statePath) this.unsubscribe = this.$ngRedux.connect(this.mapState.bind(this), {})(this);
    }

    onChange() {
        this.$ngRedux.dispatch({
            type: 'INPUT_EMAIL_CHANGE',
            id: this.identifier,
            path: this.statePath,
            index: this.stateIndex,
            input: this.model
        });
    }

    $onDestroy() {
        this.unsubscribe && this.unsubscribe();
        this.unsubscribeModule && this.unsubscribeModule();
    }

    mapModule(state) {
        return {
            module: state.navigation.module,
            regex: state.app.validation.email
        };
    }

    mapState(state) {
        return {
            model: get(state[this.module][this.identifier], this.resolvePath())
        }
    }

    resolvePath() {
        return this.stateIndex
            ? `${this.statePath}[${this.stateIndex}]`
            : this.statePath;
    }
}

InputEmailController.$inject = ['$ngRedux', '$filter'];

export const inputEmail = {
    bindings: {
        identifier: '@',
        statePath: '@',
        stateIndex: '@',
        name: '@',
        label: '@',
        required: '<',
        model: '=?',
        disable: '<'
    },
    require : {
        form : '^form'
    },
    controller: InputEmailController,
    template: `
        <md-input-container class="md-block md-icon-float md-icon-left" flex>
            <label>{{$ctrl.label}}</label>
            <asset src="email.svg"></asset>
            <input id="{{$ctrl.name}}"
                   name="{{$ctrl.name}}"
                   ng-model="$ctrl.model"
                   ng-change="$ctrl.onChange()"
                   ng-required="$ctrl.required"
                   ng-pattern="$ctrl.regex"
                   ng-disabled="$ctrl.disable">
            <div ng-messages="$ctrl.form[$ctrl.name].$error" ng-show="$ctrl.form.$submitted || $ctrl.form[$ctrl.name].$touched">
                <div ng-message="required">{{'COMMON.FIELD_REQUIRED' | translate}}</div>
                <div ng-message="pattern">{{'COMMON.EMAIL.VALID_ERROR' | translate}}</div>
            </div>
        </md-input-container>
    `
};
